"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const apollo_client_1 = require("apollo-client");
const apollo_link_1 = require("apollo-link");
const apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
const apollo_link_http_1 = require("apollo-link-http");
const apollo_link_ws_1 = require("apollo-link-ws");
const apollo_link_context_1 = require("apollo-link-context");
const uuid_1 = tslib_1.__importDefault(require("uuid"));
function clientFactory(uri, opts) {
    let link;
    if (typeof uri === "string") {
        if (!uri.startsWith("http")) {
            // TODO: maybe an issue in SSR context.
            uri = `${window.location.protocol}//${window.location.hostname}:${window.location.port}${uri}`;
        }
        const connectionId = uuid_1.default().replace(/-/g, "");
        const contextSetter = apollo_link_context_1.setContext((_, { headers }) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return {
                headers: Object.assign(Object.assign({}, headers), { ["x-request-id"]: connectionId, Authorization: yield opts.shortLiveToken() }),
            };
        }));
        if (!opts.websocketOnly) {
            link = apollo_link_1.from([
                contextSetter,
                new apollo_link_http_1.HttpLink({
                    uri,
                    credentials: "include",
                    fetch: opts.fetch,
                }),
            ]);
        }
        else {
            let wsCanSendOperations = false, wsConnectionError = undefined;
            const wsLink = new apollo_link_ws_1.WebSocketLink({
                uri: uri.replace(/http(s?):\/\//, "ws$1://"),
                options: {
                    connectionParams: () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                        const auth = yield opts.authentication();
                        return Object.assign({ requestId: connectionId }, auth);
                    }),
                    reconnect: true,
                    connectionCallback(error) {
                        wsCanSendOperations = !error;
                        wsConnectionError = error;
                    },
                },
                webSocketImpl: opts.webSocketImpl,
            });
            //Workaround for subscriptions-transport-ws issue: https://github.com/apollographql/subscriptions-transport-ws/issues/339
            {
                /* eslint-disable @typescript-eslint/ban-ts-ignore */
                //@ts-ignore
                const subscriptionClient = wsLink.subscriptionClient;
                subscriptionClient.onConnecting(() => {
                    wsCanSendOperations = false;
                    wsConnectionError = undefined;
                });
                subscriptionClient.onReconnecting(() => {
                    wsCanSendOperations = false;
                    wsConnectionError = undefined;
                });
                subscriptionClient.use([
                    {
                        applyMiddleware: (options, next) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                            let count = 0;
                            while (!wsCanSendOperations && count < 3000) {
                                if (wsConnectionError) {
                                    next(wsConnectionError);
                                    return;
                                }
                                yield new Promise(r => setTimeout(r, 10));
                                count++;
                            }
                            if (!wsCanSendOperations) {
                                next(new Error("Connection establishing timeout"));
                            }
                            else {
                                next();
                            }
                        }),
                    },
                ]);
            }
            link = wsLink;
        }
    }
    else {
        link = uri;
    }
    return new apollo_client_1.ApolloClient({
        link,
        cache: new apollo_cache_inmemory_1.InMemoryCache({
            fragmentMatcher: new apollo_cache_inmemory_1.IntrospectionFragmentMatcher({
                introspectionQueryResultData: {
                    __schema: {
                        types: [],
                    },
                },
            }),
        }),
        defaultOptions: {
            query: {
                fetchPolicy: "no-cache",
            },
        },
    });
}
exports.default = clientFactory;
//# sourceMappingURL=gqlClient.js.map